import Box from '@mui/material/Box';

import { openNewTab } from '../../../../../../utils/open-new-tab';

interface FormButtonProps {
  url: string;
  text: string;
}

export function FooterButton({ text, url }: FormButtonProps) {
  return (
    <Box style={{ cursor: 'pointer' }} onClick={() => openNewTab(url)}>
      {text}
    </Box>
  );
}
